/**
 * Hands a generated file to the user.
 *
 * A synthetic anchor click is the only way to save a Blob without a server. The object URL is
 * revoked immediately afterwards: the download has already been handed to the browser by then, and
 * leaving it alive keeps the whole file in memory for the life of the page.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();

  URL.revokeObjectURL(url);
}

export function downloadJson(value: unknown, filename: string): void {
  downloadBlob(new Blob([`${JSON.stringify(value, null, 2)}\n`], { type: 'application/json' }), filename);
}

/** Text with an explicit UTF-8 charset, so an accented note survives the round trip. */
export function downloadText(text: string, filename: string): void {
  downloadBlob(new Blob([text], { type: 'text/markdown;charset=utf-8' }), filename);
}
